module.exports = __webpack_public_path__ + "static/img/2s-img2.a9ffa84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-img2.png
// module id = 9BV7
// module chunks = 0